import { render } from "./ContentManagementDashboard.vue?vue&type=template&id=127e8eca&ts=true"
import script from "./ContentManagementDashboard.vue?vue&type=script&lang=ts"
export * from "./ContentManagementDashboard.vue?vue&type=script&lang=ts"

import "./ContentManagementDashboard.vue?vue&type=style&index=0&id=127e8eca&lang=css"

import exportComponent from "/builds/askom/io.askom.portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__